"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const react_progressive_image_1 = __importDefault(require("react-progressive-image"));
const Image = styled_components_1.default.img `
  display: block;
  width: 100%;
`;
const ProgressiveImageWrapper = (props) => {
    const { image: imageSrc, imageClass, alt, indexOfImage } = props;
    const indexImage = indexOfImage || "";
    const image = document.getElementsByClassName(`bubble-filter-image-${indexImage}`)[0];
    if (image && image.naturalHeight > 40 && image.naturalWidth > 40) {
        image.style.width = "50%";
        image.style.height = "50%";
    }
    return (react_1.default.createElement(react_progressive_image_1.default, { placeholder: "/images/other/ripple.svg", src: imageSrc }, (src) => (react_1.default.createElement(Image, { "data-testid": "progressive-image", className: imageClass, src: src, alt: alt }))));
};
exports.default = ProgressiveImageWrapper;
